<template>
  <div>
    <page-header>
      <template #breadcrumbs>
        <router-link to="/vacancies">Реестр соискателей</router-link> &raquo;
        <template v-if="item && item.patient">{{ item.patient.surname }} {{ item.patient.name }}
          {{ item.patient.patronimic }}
        </template>
      </template>
      <h2>Карточка соискателя</h2>
    </page-header>

    <ul class="nav nav-tabs nav-justified p-3 d-flex align-items-center">
      <li class="nav-item">
        <a class="nav-link" @click.prevent="setActive('tab1')" :class="{ active: isActive('tab1') }" href="#tab1">Параметры
          поиска</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click.prevent="setActive('tab2')" :class="{ active: isActive('tab2') }" href="#tab2">Факты
          трудоустройства</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click.prevent="setActive('tab3')" :class="{ active: isActive('tab3') }" href="#tab3">История
          контактов</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click.prevent="setActive('tab4')" :class="{ active: isActive('tab4') }" href="#tab4">Госуслуги</a>
      </li>
    </ul>
    <div class="card">
      <div>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab1') }" id="tab1"
               v-disable-all="isReadonly">
            <div style="display:none">
              {{ item.vacancyApplicantDates }}
            </div>
            <div class="row pb-4">
              <div class="form-group col col-md-4">
                <component-input
                    label="Должность"
                    v-model="item.position"/>
              </div>
            </div>

            <div class="row pb-4">
              <div class="form-group col col-md-4">
                <component-input
                    label="Заработок от (руб.)" :maxLength="10"
                    v-model="item.salaryFrom"/>
                <div class="invalid-msg" v-if="v$.item.salaryFrom.$error">Введите число</div>
              </div>
              <div class="form-group col col-md-4">
                <component-input
                    label="Заработок до (руб.)" :maxLength="10"
                    v-model="item.salaryTo"/>
                <div class="invalid-msg" v-if="v$.item.salaryTo.$error">Введите число</div>
              </div>
            </div>

            <div class="row pb-4">
              <div class="form-group col col-md-4">
                <label class="control-label">График работы</label>
                <div>
                  <select v-model="item.scheduleTypeId" class="form-control">
                    <option v-for="el in scheduleTypeList" :value="el.id" v-bind:key="el.id">{{ el.text }}</option>
                  </select>
                </div>
              </div>
              <div class="form-group col col-md-4">
                <label class="control-label">Тип занятости</label>
                <div>
                  <select v-model="item.employmentTypeId" class="form-control">
                    <option v-for="el in employmentTypeList" :value="el.id" v-bind:key="el.id">{{ el.text }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row pb-4">
              <div class="form-group col col-md-8">
                <label class="control-label">Навыки и качества</label>
                <textarea v-model="item.skills" class="form-control"></textarea>
              </div>
            </div>

            <div class="row pb-4">
              <div class="form-group col col-md-4">
                <component-input
                    label="Опыт работы (лет)" :maxLength="2"
                    v-model="item.workExperience"/>
                <div class="invalid-msg" v-if="v$.item.workExperience.$error">Введите число</div>
              </div>
            </div>

            <div class="row pb-4">
              <div class="form-group col col-md-4">
                <label class="control-label">Профессиональная область</label>
                <div>
                  <Select2
                      :settings="{multiple: true}"
                      :options="professionAreaList"
                      v-model="item.professionAreaIds"/>
                </div>
              </div>

            </div>
            <div class="row pb-4">
              <div class="form-group col col-md-4">
                <label class="control-label">Местоположение</label>
                <div>
                  <Select2
                      :settings="{multiple: true}"
                      :options="districtList"
                      v-model="item.districtIds"/>
                </div>
              </div>
            </div>
            <div class="row pb-4">
              <div class="col col-md-3">
                <div class="form-group">
                  <label class='control-label'>Резюме</label>
                  <file-upload width="100%" :entity="item"
                               @deleteFile="removeFile"
                               prop-name="resumeFile"
                               @uploaded="fileUploaded"/>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab2') }" id="tab2">
            <applicant-tab-work :applicant-id="item.id" :can-edit="!isReadonly"></applicant-tab-work>
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab3') }" id="tab3">
            <applicant-tab-history :applicant-id="item.id" :can-edit="!isReadonly"></applicant-tab-history>
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab4') }" id="tab4">
            <applicant-tab-service :applicant-id="item.id" :can-edit="!isReadonly"></applicant-tab-service>
          </div>
        </div>
        <div class="card-footer mt-5">
          <div class="d-flex align-items-center float-right">
            <button-component class="btn btn-primary mx-2" v-on:click="save" v-if="!isReadonly">Сохранить
            </button-component>
            <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть
            </button-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from "@/common/components/page/PageHeader";
import ButtonComponent from "@/common/ui/ButtonComponent";
import API from '../api/applicant'
import Utils from "@/common/utils";
import FileUpload from "@/common/components/FileUpload";
import ComponentInput from "@/common/components/ComponentInput";
import Constants from "@/common/constants";
import {requiredIf, numeric} from "@vuelidate/validators";
import {useVuelidate} from '@vuelidate/core'
import ApplicantTabWork from '../components/ApplicantTabWork'
import ApplicantTabHistory from '../components/ApplicantTabHistory'
import ApplicantTabService from '../components/ApplicantTabService'
import disableAll from "@/common/directives/disable-all";

export default {
  name: "ApplicantCard",
  components: {
    PageHeader,
    ButtonComponent,
    FileUpload,
    ComponentInput,
    ApplicantTabWork,
    ApplicantTabHistory,
    ApplicantTabService
  },
  directives: {
    'disable-all': disableAll
  },
  created() {
    this.loadLists();
    this.loadPage();
  },
  data() {
    return {
      id: this.$route.params.id,
      isReadonly: this.$route.params.action === "view",
      item: {},
      activeItem: 'tab1',
      professionAreaList: [],
      districtList: [],
      employmentTypeList: [
        {id: null, text: Constants.emptySelectOptionText, selected: true},
      ],
      scheduleTypeList: [
        {id: null, text: Constants.emptySelectOptionText, selected: true},
      ]
    };
  },
  methods: {
    isActive(menuItem) {
      return this.activeItem === menuItem
    },
    setActive(menuItem) {
      this.activeItem = menuItem
    },
    loadLists() {
      Utils.loadSelectOptions("district", this.districtList);
      Utils.loadSelectOptions("professionArea", this.professionAreaList);
      Utils.loadSelectOptions("employmentType", this.employmentTypeList);
      Utils.loadSelectOptions("scheduleType", this.scheduleTypeList);
    },
    loadPage() {
      API.find(this.id).then((response) => {
        if (response.data) {
          this.item = response.data;

          var self = this;
          self.item.districtIds = [];
          if (self.item.vacancyApplicantDistricts) {
            self.item.vacancyApplicantDistricts.forEach(function (n) {
              self.item.districtIds.push(n.districtId);
            });
          }

          self.item.professionAreaIds = [];
          if (self.item.vacancyApplicantProfessionAreas) {
            self.item.vacancyApplicantProfessionAreas.forEach(function (n) {
              self.item.professionAreaIds.push(n.professionAreaId);
            });
          }
        }
      });
    },
    save() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }

      var self = this;
      this.item.vacancyApplicantDistricts = [];
      this.item.districtIds.forEach(function (n) {
        self.item.vacancyApplicantDistricts.push({districtId: n});
      });

      this.item.vacancyApplicantProfessionAreas = [];
      this.item.professionAreaIds.forEach(function (n) {
        self.item.vacancyApplicantProfessionAreas.push({professionAreaId: n});
      });

      API.save(this.item).then((response) => {
        const msg = 'Данные успешно сохранены.'
        Constants.alert.fire('Сохранение', response.data.success ? msg : response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success) {
          this.$router.push({path: '/vacancies'});
        }
      });
    },
    close() {
      this.$router.push({path: '/vacancies'});
    },
    fileUploaded(e) {
      let entity = this.item;
      entity[e.propName + 'Id'] = e.data.id;
      entity[e.propName] = e.data;
    },
    removeFile() {
      this.item.resumeFile = null;
      this.item.resumeFileId = null;
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        workOrganization: {
          required: requiredIf(function () {
            return this.item.workType == 1
          })
        },
        salaryFrom: {numeric},
        salaryTo: {numeric},
        workExperience: {numeric},
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.nav-tabs {
  justify-content: center;
  border: none;

  .nav-item {
    max-width: 240px;
    width: 100%;
    margin-top: 12px;
    min-width: 250px;
    margin-left: 8px;
    margin-right: 8px;

    .nav-link {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 14.5px 20px;
      font-family: "Source Sans Pro", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      color: $gray-dark;
      border: 1px solid $gray-light1;
      box-sizing: border-box;
      border-radius: 6px;

      &.active {
        color: $blue-light;
        border: 1px solid $blue-light;
      }
    }
  }
}

.card {
  padding: 24px;
  margin: 16px 24px 0 24px;
  border-radius: 12px;
  border: none;
  box-shadow: none;
  background-color: #fff;
}

</style>